<template>
  <a href="#nd-sidebar" @click="click" data-bs-toggle="collapse" class="nd-toggle-sidebar ui-sidebar-handle"></a>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: "SidebarToggle",
  methods: {
    click() {
      document.body.classList.toggle('nd-sidebar-closed');
    }
  }
});
</script>
